import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { User as UserType } from "@supabase/supabase-js";
import { NotificationBell } from "../../notifications/NotificationBell";
import { ProfileCompletenessIndicator } from "../../profile/ProfileCompletenessIndicator";
import { UserMenu } from "./UserMenu";
import { MobileProfileSheet } from "./MobileProfileSheet";

interface AuthSectionProps {
  user: UserType | null;
  userRole: string | null;
  onSignOut: () => void;
  getDashboardLink: () => string;
}

export function AuthSection({
  user,
  userRole,
  onSignOut,
  getDashboardLink,
}: AuthSectionProps) {
  return (
    <div className="flex items-center space-x-4">
      {user ? (
        <>
          <div className="hidden md:flex items-center space-x-4">
            <ProfileCompletenessIndicator />
            <NotificationBell />
            <UserMenu
              user={user}
              userRole={userRole}
              onSignOut={onSignOut}
              getDashboardLink={getDashboardLink}
            />
          </div>
          <div className="md:hidden">
            <MobileProfileSheet
              user={user}
              userRole={userRole}
              onSignOut={onSignOut}
              getDashboardLink={getDashboardLink}
            />
          </div>
        </>
      ) : (
        <div className="flex items-center space-x-2">
          <Link to="/login">
            <Button variant="ghost" className="text-gray-300">
              Login
            </Button>
          </Link>
          <Link to="/register">
            <Button className="bg-primary hover:bg-primary-dark">
              Sign Up
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
}
